/* eslint-env jquery */
const $ = jQuery;

$(document).ready(initHeroLCP);

if ($('.hero.option1').length) {
  $(document).ready(heroOverlap);
}

if ($('.hero.option3').length) {
  $(document).ready(heroMatchHeight);
  $(window).on('resize', heroMatchHeight);
}

function heroOverlap() {
  if ($('section.hero.option1').next().hasClass('three-image-text section-overlap')) {
    $('section.hero.option1 .hero-content').addClass('overlap');
  }
}

function heroMatchHeight() {
  if (window.matchMedia('(max-width: 575.98px)').matches) {
    const contentHeight = $('section.hero.option3 .hero-content').outerHeight();
    const imagesHeight = $('section.hero.option3 .hero-image').outerHeight();
    const totalHeight = contentHeight + imagesHeight - 90;
    $('section.hero.option3').css('height', `${totalHeight}px`);
  }
}

function initHeroLCP() {
  const $section = $('[data-lcp="true"]');

  if (!$section.length) {
    return;
  }

  const bgUrl = $section.data('bg');
  if (!bgUrl) {
    return;
  }

  const img = new Image();
  img.addEventListener('load', () => {
    $section.css('backgroundImage', `url(${bgUrl})`);
  });
  img.src = bgUrl;
}
